import { Box, Typography, ButtonProps } from '@mui/material';
import Illustration from '@/assets/illustration.svg';
import Close from '@/assets/close.svg';
import { styles } from './styles';
import Button from '../button/Button';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface CustomPopupProps {
  title: string;
  description: string;
  popupHidden: boolean;
  image?: string;
  imageHidden: boolean;
  closeHidden: boolean;
  closeAction: () => void;
  buttonTitleArray: string[];
  buttonOnlyTextArray: boolean[];
  buttonOutlinedArray: boolean[];
  buttonColorArray: ButtonProps['color'][];
  buttonActionArray: (() => void)[];
  buttonLoadingArray?: boolean[];
  isDisabled?: boolean;
  showObservationMessage?: boolean;
}

const CustomPopup = ({
  title,
  description,
  popupHidden,
  image,
  imageHidden,
  closeHidden,
  closeAction,
  buttonTitleArray,
  buttonOnlyTextArray,
  buttonOutlinedArray,
  buttonColorArray,
  buttonActionArray,
  buttonLoadingArray = [],
  isDisabled = false,
  showObservationMessage = false,
}: CustomPopupProps) => {
  const {t} = useTranslation('common');
  const renderButton = (index: number) => (
    <Button
      key={index}
      title={buttonTitleArray[index]}
      onlyText={buttonOnlyTextArray[index]}
      outlined={buttonOutlinedArray[index]}
      color={buttonColorArray[index]}
      width={'280px'}
      height={'40px'}
      onClick={buttonActionArray[index]}
      disable={isDisabled}
      loading={buttonLoadingArray[index] || false}
    />
  );

  return !popupHidden ? (
    <Box sx={styles.overlay} onClick={closeAction}>
      <Box sx={styles.background} />
      <Box sx={styles.container} onClick={(e) => e.stopPropagation()}>
        <Box style={styles.closeBox}>
          {!closeHidden && (
            <img src={Close} alt="Close" onClick={closeAction} />
          )}
        </Box>
        <Box sx={styles.content}>
          <Box style={styles.illustrationContent}>
            {!imageHidden && (
              <img
                src={image ?? Illustration}
                alt={'Illustration'}
                style={styles.illustrationImage}
              />
            )}
          </Box>

          <Box style={styles.titleBox}>
            <Typography sx={styles.title}>{title}</Typography>
          </Box>
          <Box style={styles.descriptionBox}>
            <Typography sx={styles.description}>{description}</Typography>
          </Box>
        </Box>
        <Box sx={styles.buttonContent}>
          {buttonTitleArray.map((_, index) => renderButton(index))}
        </Box>
        {showObservationMessage && (
          <Box sx={{ marginTop: 2, textAlign: 'center' }}>
            <Typography sx={{ fontSize: 14, fontWeight: 'bold' }}>
              {t('warning_cancelarion_refund_title')}
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Typography sx={{ fontSize: 12 }}>
                <strong>+24h:</strong> {t('warning_cancelarion_refund')}
              </Typography>
              <Typography sx={{ fontSize: 12 }}>
                <strong>-24h:</strong>{t('warning_cancelarion_no_refund')}
              </Typography>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  ) : null;
};

export default React.memo(CustomPopup);
